import React from "react";
import Link from "@/components/LocalizedLink";
import { useTranslation } from "react-i18next";
import { Facebook, Instagram, Mail, Cookie } from "lucide-react";
import { openCookiePreferences } from "@/components/CookieBanner";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_napoli-artigianalita/artifacts/ff6wp22h_logo%20CC.png";

const STORIA_LINKS = [
  { key: "nav.origini", to: "/le-origini" },
  { key: "nav.tempo", to: "/nel-tempo" },
  { key: "nav.road", to: "/on-the-road" },
];
const AZIENDA_LINKS = [
  { key: "nav.tostatura", to: "/la-tostatura" },
  { key: "nav.miscele", to: "/le-miscele" },
  { key: "nav.camillo", to: "/zio-camillo" },
  { key: "nav.mondo", to: "/nel-mondo" },
];

const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();
  const SOCIALS = [
    { Icon: Facebook, label: t("footer.socialFacebook"), href: "https://www.facebook.com/caffecola1960", external: true },
    { Icon: Instagram, label: t("footer.socialInstagram"), href: "https://www.instagram.com/caffecola1960", external: true },
    { Icon: Mail, label: t("footer.socialMail"), href: "mailto:caffecola1960@libero.it", external: false },
  ];

  return (
    <footer id="footer" style={{ background: "#1d0f08", color: "#ecdcbd" }} data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-2">
            <img src={LOGO_URL} alt="Caffè Cola 1960" className="h-20 w-auto" />
            <p className="mt-4 max-w-md text-sm leading-relaxed" style={{ color: "#e0c89a" }}>
              {t("footer.tagline")}
            </p>
            <div className="mt-5 flex items-center gap-3">
              {SOCIALS.map(({ Icon, label, href, external }, i) => (
                <a
                  key={i}
                  href={href}
                  target={external ? "_blank" : undefined}
                  rel={external ? "noopener noreferrer" : undefined}
                  className="w-10 h-10 rounded-full inline-flex items-center justify-center transition hover:scale-110"
                  style={{ background: "#c5371f" }}
                  aria-label={label}
                >
                  <Icon size={16} color="#fff" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="font-serif-display font-semibold text-base uppercase tracking-wider mb-4" style={{ color: "#fbf5e9" }}>
              {t("footer.colStoria")}
            </h4>
            <ul className="space-y-2 text-sm">
              {STORIA_LINKS.map((it) => (
                <li key={it.to}>
                  <Link to={it.to} className="hover:text-white transition" style={{ color: "#e0c89a" }}>
                    {t(it.key)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-serif-display font-semibold text-base uppercase tracking-wider mb-4" style={{ color: "#fbf5e9" }}>
              {t("footer.colAzienda")}
            </h4>
            <ul className="space-y-2 text-sm">
              {AZIENDA_LINKS.map((it) => (
                <li key={it.to}>
                  <Link to={it.to} className="hover:text-white transition" style={{ color: "#e0c89a" }}>
                    {t(it.key)}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-serif-display font-semibold text-base uppercase tracking-wider mb-4" style={{ color: "#fbf5e9" }}>
              {t("footer.colContatti")}
            </h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/#contatti" className="hover:text-white transition" style={{ color: "#e0c89a" }}>
                  {t("footer.contactLink")}
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t" style={{ borderColor: "rgba(245,234,214,0.08)" }}>
        <div
          className="max-w-7xl mx-auto px-6 lg:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs"
          style={{ color: "#c0a986" }}
        >
          <p>{t("footer.copyright", { year })}</p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 justify-center">
            <Link to="/privacy-policy" className="hover:text-white transition">
              {t("footer.privacy")}
            </Link>
            <Link to="/cookie-policy" className="hover:text-white transition">
              {t("footer.cookie")}
            </Link>
            <button
              onClick={openCookiePreferences}
              className="inline-flex items-center gap-1.5 hover:text-white transition"
              data-testid="footer-cookie-prefs"
            >
              <Cookie size={12} /> {t("footer.cookiePrefs")}
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
